angular.module('unergie.main')
.directive('userNotifPopup', ($window, $state, ModalService, UserNotificationService, NotificationService, MetaWatcher) =>
    ({
        restrict: 'E',
        templateUrl: '/directives/userNotifPopup/userNotifPopup.html',
        link($scope) {
            const textLimit = 150
            $scope.limit = 15

            $scope.refreshNotifs = () => {
                $scope.notifs = UserNotificationService.listNotif()
            }

            $scope.removeAll = (e, limit) => {
                e.preventDefault()
                e.stopPropagation()
                UserNotificationService.removeAll(limit)
            }

            $scope.strip = (notif) => {
                if (notif.msg && notif.msg.length > textLimit) {
                    return `${notif.msg.slice(0, textLimit)} ...`
                }
                return notif.msg
            }

            $scope.remove = (notif, e) => {
                e.preventDefault()
                e.stopPropagation()
                UserNotificationService.removeNotif(notif)
            }

            $scope.open = () => {
                $scope.opened = true
            }

            $scope.computeText = (notif) => {
                if (!_.isArray(notif.detail)) {
                    notif.detail = [notif.detail]
                }
                const notifs = _.map(notif.detail, (d) => {
                    if (_.isObject(d)) {
                        return JSON.stringify(d)
                    }
                    return d
                }).join('\n\t- ')
                return notif.msg + (notif.detail && notif.detail.length ? (`: \n\t- ${notifs}`) : '')
            }

            $scope.clickable = (notif) => {
                return !!(notif.url || notif.state || notif.result || notif.modal)
            }

            $scope.clickNotif = (notif, e) => {
                e.preventDefault()
                e.stopPropagation()
                if (notif.url) {
                    $window.open(notif.url, '_blank')
                } else if (notif.state) {
                    $state.go(notif.state, notif.stateParams)
                } else if (notif.result) {
                    ModalService.openModal({ type: 'resultModal', size: 'lg' }, { result: {
                        processed: notif.result.processed,
                        errors: notif.result.errors,
                    } })
                } else if (notif.modal) {
                    ModalService.openModal(notif.modal, notif.modal.payload)
                }
            }

            $scope.mutePayload = {
                for: 30,
            }

            $scope.muteFields = {
                for: {
                    label: 'Pour combien de temps',
                    type: 'radio',
                    enum: [
                        { label: '30 min', value: 30 },
                        { label: '1h', value: 60 },
                        { label: '2h', value: 120 },
                        { label: `Aujourd'hui`, value: 'today' },
                    ],
                },
            }

            $scope.muteNotif = (notif) => {
                const until = ($scope.mutePayload.for === 'today' ? moment().endOf('day') : moment().add($scope.mutePayload.for, 'minute')).toISOString()
                return NotificationService.muteNotif(notif.eventType, until)
            }

            MetaWatcher.watch('USER_NOTIFS', 'userNotifPopup', $scope, $scope.refreshNotifs)

            $scope.refreshNotifs()
        },
    })
)
